<template>
  <el-dialog v-model="visible" title="个人中心" width="400px" :close-on-click-modal="false" @close="handleDialogClose">
    <el-form :model="form" label-width="80px" class="edit-form">
      <el-form-item label="昵称">
        <el-input v-model="form.nickName" />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input v-model="form.phone" disabled />
      </el-form-item>
      <el-form-item label="原始密码">
        <el-input v-model="form.oldPassword" type="password" :show-password="true" placeholder="请输入原始密码" />
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="form.password" type="password" :show-password="true" placeholder="请输入新密码" />
      </el-form-item>
      <!-- <el-form-item label="拖动验证">
        <SliderCaptcha v-model="sliderPassed" ref="sliderCaptchaRef" />
      </el-form-item> -->
      <!-- <el-form-item label="验证码">
        <el-input v-model="form.smsCode" maxlength="6" placeholder="请输入验证码" style="width: 140px;" />
        <el-button :disabled="!sliderPassed || smsCountdown > 0 || !form.phone" @click="getSmsCode" style="margin-left:8px;">
          {{ smsCountdown > 0 ? smsCountdown + 's' : '获取验证码' }}
        </el-button>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="saveProfile">保存修改</el-button>
      </el-form-item>
    </el-form>
    

  </el-dialog>
</template>


<script setup lang="ts">
import { ref, reactive, watch } from 'vue'
// import SliderCaptcha from '@/components/common/SliderCaptcha.vue'
import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'
import { sendCode, updateUserInfo as updateUser } from '@/api/auth' // 如有短信接口可解注
import type { SysUserInfo } from '@/types/user' // 确保导入了正确的类型定义

const sliderCaptchaRef = ref()

const props = defineProps({
  showProfile: Boolean
})
const emit = defineEmits(['update:showProfile'])
const visible = ref(props.showProfile)
watch(() => props.showProfile, val => visible.value = val)
watch(visible, val => emit('update:showProfile', val))

const resetForm = () => {
  form.id = 0
  form.nickName = ''
  form.phone = ''
  form.password = ''
  form.oldPassword = ''
  form.smsCode = ''
  smsCountdown.value = 0
  sliderPassed.value = false
  sliderCaptchaRef.value?.reset()
  if (smsTimer) {
    clearInterval(smsTimer)
    smsTimer = null
  }
}

const handleDialogClose = () => {
  resetForm()
}

const userStore = useUserStore()
const form = reactive<SysUserInfo>({
  id: 0,
  nickName: '',
  phone: '',
  password: '',
  oldPassword: '',
  smsCode: ''
})

// 每次弹窗打开时同步用户信息
watch(visible, (val) => {
  if (val && userStore.userInfo) {
    form.id = userStore.userInfo.id
    form.nickName = userStore.userInfo.nickName || ''
    form.phone = userStore.userInfo.phone || ''
    form.password = ''
    form.smsCode = ''
  }
})
const smsCountdown = ref(0)
const sliderPassed = ref(false)
let smsTimer: any | null = null

const getSmsCode = async () => {
  if (!form.phone) {
    ElMessage.warning('请输入手机号')
    return
  }
  //这里应调用实际API
  const res = await sendCode(form.phone)
  if (res.data.code === 200) {
  ElMessage.success('验证码已发送')
  smsCountdown.value = 60
  smsTimer = setInterval(() => {
    smsCountdown.value--
    if (smsCountdown.value <= 0) clearInterval(smsTimer)
  }, 1000)
  } else {
    ElMessage.error(res.data.msg || '发送失败')
  }
}

const saveProfile = async () => {
  // if (form.password && !form.smsCode) {
  //   ElMessage.warning('请输入验证码')
  //   return
  // }
  userStore.updateUserInfo({
    nickName: form.nickName
  })
  try {
    const res = await updateUser(form)
    if(res.data.code !== 200) {
      ElMessage.error(res.data.msg || '更新失败')
      return
    }
    ElMessage.success('保存成功')
    resetForm()
  } catch (error) {
    ElMessage.error('保存失败') 
  }
  
}
</script>

<style scoped>
.edit-form {
  margin-bottom: 0;
}

.profile-actions {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.profile-actions .el-button {
  font-size: 14px;
  margin-top: 24px;
}
</style>
